export default __webpack_public_path__ + "static/media/filterIcon.abb8f2ba.svg";